import { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '~portal/styles/cookie-consent.css';
import { getAppEnv } from '~portal/env';
import { runCookieConsent } from './cookie-consent';
import { logger } from './logger';

/**
 * @desc Mounts the cookie consent banner (H2-204), ported from h2gc.com. Renders nothing itself:
 * `vanilla-cookieconsent` owns its own DOM under `#cc-main`, outside the React tree, which is why
 * this sits beside `DatadogRUM` rather than inside the Mantine provider. The theme is applied by
 * `styles/cookie-consent.css` through Mantine's runtime CSS variables, so it follows the light,
 * dark and blue schemes without any React involvement.
 */
export function CookieConsentBanner() {
  useEffect(() => {
    // The library focuses its container on show, and browsers scroll to reveal a focused node —
    // a bottom-anchored banner would yank a scrolled page. Focus without scrolling for anything
    // inside `#cc-main`; every other element keeps native behaviour. Same workaround as legacy.
    const nativeFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (this: HTMLElement, options?: FocusOptions) {
      nativeFocus.call(
        this,
        this.closest('#cc-main') ? { ...options, preventScroll: true } : options,
      );
    };

    runCookieConsent(getAppEnv().cookieConsent).catch((error: unknown) =>
      logger.error('cookie consent banner failed to start', { error }),
    );

    return () => {
      HTMLElement.prototype.focus = nativeFocus;
    };
  }, []);

  return null;
}
